import AidolQuestionnaireUI from "@aidol/questionnaire-ui";
import "@aidol/questionnaire-ui/dist/AidolQuestionnaireUI.css";

export default {
  install(Vue) {
    Vue.use(AidolQuestionnaireUI)

    Vue.component('CsQuestion', () => import('./components/csQuestion.vue'));
  }
};



// WEBPACK FOOTER //
// ./src/core/questionnaire-ui/index.js